import makeVariant from '../makeVariant';
/**
 * Gets the button's style.
 * @param {String} variant The button variant.
 */
export const getVariant = makeVariant(
  /* Any default styles here. */
  {
    // e.g.: color: 'primary',
    borderRadius: 'default',
  },
  {
    default: {},

    primary: {
      color: 'onPrimary',
      backgroundColor: 'primary',
      borderColor: 'primary',
    },

    onDark: {
      color: 'primary',
      backgroundColor: 'onPrimary',
      borderColor: 'onPrimary',
    },
  }
);

export const Base = {
  borderStyle: 'solid',
  borderWidth: '1px',
  cursor: 'pointer',
  display: 'inline-block',
  paddingX: '12px',
  paddingY: '6px',
  textAlign: 'center',
  ':hover': {
    textDecoration: 'none',
  },
  '::-moz-focus-inner': {
    border: 0,
  },
  ':focus': {
    outline: 'none',
  },
};

export const ButtonGroup = {};

export const ButtonToolbar = {};

export const ToggleButtonGroup = {};
